export default {"src":"/_next/static/media/HAYW.73011217.svg","height":18,"width":18};